<template>
  <div>
    <menu-bar></menu-bar>

<!--    <div style="padding: 12px;height: 100%" v-loading="loading" element-loading-text="下载数据中,请耐心等待">-->
<!--      <div style="width: 750px;margin: 0 auto;">-->
<!--        <div style="margin-bottom: 12px">-->
<!--          <el-alert-->
<!--            title="若导出失败,请检查是否已开通API权限"-->
<!--            type="warning">-->
<!--          </el-alert>-->
<!--        </div>-->
<!--        <div style="display: flex;align-items: center">-->
<!--          <div style="width: 200px">-->
<!--            导出DMarket账单-->
<!--          </div>-->
<!--          <el-input placeholder="请输入publicKey或cookie" style="width: 300px" v-model="exportForm.publicKey"></el-input>-->
<!--          <el-input placeholder="请输入导出条数" style="width: 300px;margin-right: 12px" v-model="exportForm.total">-->
<!--            <template slot="prepend">导出条数</template>-->
<!--          </el-input>-->
<!--          <el-button type="primary" plain @click="exportDMarket">-->
<!--            下载Excel-->
<!--          </el-button>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

    <div class="download-container">
      <button
        class="download-btn"
        :class="{ loading, success, error }"
        @click="startDownload"
        :disabled="loading"
      >
      <span v-if="!loading && !success && !error" class="btn-text">
        <i class="fas fa-download"></i>
        下载Steam撤回报价插件
      </span>

        <span v-if="loading" class="loading-state">
        <div class="spinner"></div>
        <span class="progress-text">
          正在下载 {{ progress }}%
        </span>
      </span>

        <span v-if="success" class="success-state">
        <i class="fas fa-check"></i>
        下载完成
      </span>

        <span v-if="error" class="error-state">
        <i class="fas fa-exclamation-triangle"></i>
        下载失败
      </span>
      </button>

      <p class="download-info" v-if="showInfo">
        适用于Chrome浏览器的Steam交易跟踪插件，下载后在扩展程序中启用开发者模式并加载
      </p>
    </div>

  </div>
</template>

<script>
import MenuBar from "../Menu/menuBar.vue";
import {exportDMarketExcel} from "../../api/api";

export default {
  name: "Tools",
  components: {MenuBar},
  data() {
    return {
      exportForm: {
        publicKey: '',
        total: 500
      },
      loading: false,
      success: false,
      error: false,
      progress: 0,
      showInfo: false,
      downloadUrl: 'https://hangknife.com/plugins/SteamOfferWithdrawalTracker.zip'
    }
  },
  methods: {
    async exportDMarket() {
      try {
        this.loading = true
        if (!this.exportForm.publicKey) {
          this.$message.error('请输入DMarket的publicKey');
          return;
        }
        if (!this.exportForm.total) {
          this.$message.error('请输入导出条数');
          return;
        }

        const response = await exportDMarketExcel({
          publicKey: this.exportForm.publicKey, // 替换为实际的 publicKey
          total: this.exportForm.total
        })

        if (!response || response.success === false) {
          // 如果返回的信息包含特定错误信息，则根据情况提示用户
          const errorMessage = response.message || '导出失败,请检查是否开通API权限';
          this.$message.error(errorMessage);
          return;
        }

        // 创建一个下载链接
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'DMarketHistory.xlsx'); // 设置下载文件名
        document.body.appendChild(link);
        link.click();

        // 移除链接
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);

        this.loading = false
      } catch (error) {
        console.error("导出失败:", error);
      }
    },
    startDownload() {
      // 重置状态
      this.loading = true
      this.success = false
      this.error = false
      this.progress = 0

      // 创建隐藏的下载链接
      const link = document.createElement('a')
      link.href = this.downloadUrl
      link.download = 'SteamOfferWithdrawalTracker.zip'
      document.body.appendChild(link)

      // 模拟进度（实际项目中可根据需要替换为真实进度监听）
      const progressInterval = setInterval(() => {
        this.progress += Math.floor(Math.random() * 10) + 1
        if (this.progress >= 100) {
          this.progress = 100
          clearInterval(progressInterval)

          // 触发下载
          link.click()

          // 显示成功状态
          setTimeout(() => {
            this.loading = false
            this.success = true

            // 5秒后重置按钮状态
            setTimeout(() => {
              this.success = false
            }, 5000)
          }, 500)
        }
      }, 300)

      // 错误处理（实际项目中可根据需要添加真实错误监听）
      setTimeout(() => {
        if (this.loading && this.progress < 100) {
          clearInterval(progressInterval)
          this.loading = false
          this.error = true

          // 5秒后重置错误状态
          setTimeout(() => {
            this.error = false
          }, 5000)
        }
      }, 15000)

      document.body.removeChild(link)
    }
  },
  mounted() {
    this.showInfo = false
  }
}
</script>

<style scoped>
.download-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin: 20px 0;
}

.download-btn {
  position: relative;
  padding: 14px 32px;
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 200px;
  overflow: hidden;
}

.download-btn:hover {
  background: #2563eb;
  transform: translateY(-2px);
  box-shadow: 0 10px 25px -5px rgba(59, 130, 246, 0.4);
}

.download-btn:active {
  transform: translateY(0);
  box-shadow: 0 4px 6px -1px rgba(59, 130, 246, 0.4);
}

.download-btn:disabled {
  cursor: not-allowed;
  opacity: 0.8;
}

/* 加载状态样式 */
.download-btn.loading {
  background: #93c5fd;
  cursor: wait;
}

.spinner {
  width: 20px;
  height: 20px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: white;
  animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.loading-state {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  justify-content: center;
}

/* 成功状态样式 */
.download-btn.success {
  background: #10b981;
}

.success-state {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* 错误状态样式 */
.download-btn.error {
  background: #ef4444;
}

.error-state {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* 下载信息 */
.download-info {
  color: #64748b;
  font-size: 14px;
  max-width: 500px;
  text-align: center;
  margin: 0;
  padding: 8px 16px;
  border-radius: 6px;
  background: #f1f5f9;
  transition: all 0.3s ease;
}

/* 进度条动画效果 */
.download-btn::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 100%;
  background: rgba(255, 255, 255, 0.1);
  transition: width 0.3s ease;
}

.download-btn.loading::after {
  width: calc(100% * var(--progress, 0) / 100);
}

/* 响应式调整 */
@media (max-width: 768px) {
  .download-btn {
    padding: 12px 24px;
    font-size: 14px;
  }

  .download-info {
    font-size: 13px;
    max-width: 90%;
  }
}
</style>



// WEBPACK FOOTER //
// src/ui/Tools/Tools.vue